<div
  data-tms-event="popup-impression"
  data-tms-popup-zone="e-press"
  data-tms-popup-name="activate e-press"
  attr.data-tms-product="{{ jsonProduct }}"
>
  <div class="rs-modal-close">
    <button
      class="rs-link-action rs-link-action-close close-reveal-modal"
      data-tms-button-name="close"
      data-tms-action-name="close"
    >
      <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>

  <div class="rs-modal-heading">
    <h2 id="confirmationModalTitle1" [innerHTML]="title"></h2>
  </div>
  <div class="rs-modal-content">
    <p [innerHTML]="description"></p>
  </div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <button
          class="rs-btn jsrs-confirm-press-change1"
          (click)="confirmSwap()"
          data-tms-button-name="confirm"
          data-tms-action-name="activate confirm"
        >
          {{ confirmButtonLabel }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <p class="small-only-text-center">
          <a
            href="javacript:void(0)"
            (click)="close()"
            role="button"
            data-modal-close=""
            data-tms-button-name="cancel"
            data-tms-action-name="close"
          >
            {{ cancelButtonLabel }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
